import { CoreIconButton } from "@verity/components/core";
import i18n from "../../../../../../../i18n";
import { PencilIcon } from "../../../assets";

type EditProps = {
	onClick: () => void;
};

export default function EditButton({ onClick }: EditProps) {
	return (
		<CoreIconButton startIcon={<PencilIcon />} onClick={onClick}>
			{i18n.t(`candidate.scheduleInterview.reviewStep.edit`)}
		</CoreIconButton>
	);
}
